var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElements(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.21711 1.44336C8.49859 1.23908 8.63933 1.13694 8.79318 1.09747C8.92903 1.06262 9.07147 1.06262 9.20732 1.09747C9.36117 1.13694 9.50191 1.23908 9.78339 1.44336L16.5489 6.3533C16.8309 6.55797 16.9719 6.6603 17.0572 6.79459C17.1325 6.91317 17.1766 7.04885 17.1854 7.18904C17.1953 7.3478 17.1414 7.51348 17.0337 7.84484L14.4501 15.7874C14.3424 16.1184 14.2886 16.2839 14.1873 16.4063C14.0978 16.5144 13.9825 16.5982 13.852 16.6499C13.7042 16.7083 13.5302 16.7083 13.1821 16.7083H4.81836C4.47031 16.7083 4.29629 16.7083 4.14852 16.6499C4.01804 16.5982 3.90271 16.5144 3.81324 16.4063C3.71191 16.2839 3.65808 16.1184 3.55042 15.7874L0.966839 7.84484C0.859054 7.51348 0.805161 7.3478 0.815139 7.18904C0.823948 7.04885 0.86805 6.91317 0.943346 6.79459C1.02862 6.6603 1.16963 6.55797 1.45164 6.3533L8.21711 1.44336Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M1.08334 6.91667L14 16.5",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M9 1.08333L13.5833 16.5",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M17.3333 7.33333L11.9167 10.6667",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElements);
export default __webpack_public_path__ + "static/media/Elements.69a599975f0ff79f1235d0cc4c389869.svg";
export { ForwardRef as ReactComponent };